export default class ShadowDom {
    protected domContainer: NodeListOf<HTMLElement> = null;

    constructor() {
        const _this = this;
        _this.domContainer = document.querySelectorAll('div.shadowDom');
        if (!_this.domContainer.length) {
            return;
        }
        _this.domContainer.forEach((element) => {
            let shadow = element.parentElement.attachShadow({ mode: 'open' });
            shadow.appendChild(element);
        });
    }
}
